<template>
    <div id="workreportmonth">
        <div style="width: 100%;height: 120px;border-bottom: 2px dashed #eee">
            <el-row style="height: 100%">
                <el-col span="12" style="height: 100%">
                    <el-row>
                        <el-col span="24">
                            <span class="demonstration" style="margin-right: 15px">年月</span>
                            <el-date-picker
                                    v-model="value2"
                                    type="month"
                                    placeholder="选择年月">
                            </el-date-picker>
                        </el-col>
                        <el-col span="24" style="margin-top: 24px">
                            <el-button type="primary" size="small" @click="searchWeekList"
                                       style="background: #4EC880;border: none">
                                查询
                            </el-button>
                            <el-button type="danger" size="small" @click="ResetClick"
                                       style="background: #D0021B;border: none">
                                重置
                            </el-button>
                        </el-col>
                    </el-row>
                </el-col>
                <el-col span="12" style="height: 100%">
                    <div style="float: right">
                   <span style="margin-right: 15px">
                       人员
                   </span>
                        <inputSelect :handleSelectInput="handleSelectInputClick" ></inputSelect>
                    </div>

                </el-col>
            </el-row>
        </div>
        <el-row style="margin-top: 15px">
            <el-col span="24" style="">
                <span style="vertical-align:middle;font-size: 17px">
                    2019年9月16日——2019年9月22日
                </span>
                <span style="font-size: 12px;margin-left: 10px;color:#FF9901;vertical-align:middle">
                    团队成员 128人
                </span>
                <span style="font-size: 12px;margin-left: 10px;color: #4A90E2;vertical-align:middle">
                    医疗机构总数 2083 | 门店总数 819 |  经销商总数 232
                </span>
            </el-col>
        </el-row>
        <el-row style="margin-top: 5px;height: auto;overflow: hidden;">
            <el-row style="position: relative">
                <el-col span="7" style="height: 100%">
                    <ul style="height: 100%;margin-top: 10px;margin-right: 0">
                        <li class="li" >
                        <span class="li_span" style="vertical-align: bottom">
                            辖区签到
                        </span>
                            <span class="li_spanR" style="vertical-align: bottom">
                            327 家客户，98个场所
                        </span>
                        </li>
                        <li class="li">
                         <span class="li_span" style="vertical-align: bottom">
                            医务拜访
                        </span>
                            <span class="li_spanR" style="vertical-align: bottom">
                            209 家机构，814 位HCP
                        </span>
                        </li>
                        <li class="li">
                         <span class="li_span" style="vertical-align: bottom">
                            门店巡查
                        </span>
                            <span class="li_spanR" style="vertical-align: bottom">
                            106 家门店
                        </span>
                        </li>
                        <li class="li">
                         <span class="li_span" style="vertical-align: bottom">
                            商务拜访
                        </span>
                            <span class="li_spanR" style="vertical-align: bottom">
                            21家经销商
                        </span>
                        </li>
                    </ul>
                </el-col>
                <el-col span="1" style="border: 1px transparent solid;">
                    <div style="height: 100px;border: 1px solid #bbbbbb;width: 0px;margin: 50px auto">

                    </div>
                </el-col>
                <el-col span="7">
                    <ul  style="height: 100%;margin-top: 10px">
                        <li class="li" >
                        <span class="li_span" style="vertical-align: middle">
                            会议/活动
                        </span>
                            <span class="li_spanR" style="margin: 0">
                            <span style="vertical-align:middle">9场</span>
                            <span
                                    style="vertical-align:middle;display: inline-block;padding: 4px 10px;background:#7ED321;
                                    color: white;border-radius: 4px;margin-top: 4px;
                                    font-size: 12px ">
                                科室会</span>
                             <span
                                     style="vertical-align:middle;display: inline-block;padding: 4px 10px;background:#7ED321;
                                    color: white;border-radius: 4px;margin-top: 4px;
                                    font-size: 12px ">
                                院级交流</span>
                             <span
                                     style="vertical-align:middle;display: inline-block;padding: 4px 10px;background:#7ED321;
                                    color: white;border-radius: 4px;margin-top: 4px;
                                    font-size: 12px ">
                                城市会</span>
                        </span>
                        </li>
                        <li class="li">
                         <span class="li_span" style="vertical-align: middle">
                            辅导/协访
                        </span>
                            <span class="li_spanR" >
                            <span>
                                18次
                            </span>
                            <span
                                    style="vertical-align:middle;display: inline-block;padding: 4px 10px;background:#FF9901;
                                    color: white;border-radius: 4px;margin-top: 4px;
                                    font-size: 12px ">
                                示范式辅导拜访</span>
                            <span
                                    style="vertical-align:middle;display: inline-block;padding: 4px 10px;background:#FF9901;
                                    color: white;border-radius: 4px;margin-top: 4px;
                                    font-size: 12px ">
                                支援式辅导拜访</span>
                            <span
                                    style="vertical-align:middle;display: inline-block;padding: 4px 10px;background:#FF9901;
                                    color: white;border-radius: 4px;margin-top: 4px;
                                    font-size: 12px ">
                                联合拜访</span>
                        </span>
                        </li>
                        <li class="li">
                         <span class="li_span" style="vertical-align: middle">
                            差旅计划
                        </span>
                            <span class="li_spanR" >
                           13个城市
                        </span>
                        </li>
                        <li class="li" >
                         <span class="li_span" style="vertical-align: middle">
                            请假/休假
                        </span>
                            <span class="li_spanR" >
                           年假 [7天], 事假 [1.5天]
                        </span>
                        </li>
                        <li class="li">
                         <span class="li_span">
                            内部事务
                        </span>
                            <span class="li_spanR" >
                           产品培训 [2.5天]
                        </span>
                        </li>
                    </ul>
                </el-col>
                <el-col span="1" style="border: 1px transparent solid;">
                    <div style="height: 100px;border: 1px solid #bbbbbb;width: 0px;margin: 50px auto">

                    </div>
                </el-col>
                <el-col span="7">
                    <div style="width: 100%;height: 100%">
                        <ul style="width: 100%;max-width: 300px;margin: auto">
                            <li style="margin-top: 16px;overflow: hidden;width: 100%">
                                <div style="width: 50px;height: 20px;float: left;line-height: 20px">
                                    A类
                                </div>
                                <div style="float: left;width: calc(100% - 50px)">
                                    <el-progress  :stroke-width="20"  :percentage="98"
                                                  style="margin-bottom: 5px;width: 100%">
                                    </el-progress>
                                    <span style="float: right;color: #4A90E2;font-size: 12px;">目标客户总数 53人，当月已拜访 53人</span>
                                </div>
                            </li>
                            <li style="margin-top: 16px;overflow: hidden;width: 100%">
                                <div style="width: 50px;height: 20px;float: left;line-height: 20px">
                                    A类
                                </div>
                                <div style="float: left;width: calc(100% - 50px)">
                                    <el-progress  :stroke-width="20"  :percentage="98"
                                                  style="margin-bottom: 5px;width: 100%">
                                    </el-progress>
                                    <span style="float: right;color: #4A90E2;font-size: 12px;">目标客户总数 53人，当月已拜访 53人</span>
                                </div>
                            </li>
                            <li style="margin-top: 16px;overflow: hidden;width: 100%">
                                <div style="width: 50px;height: 20px;float: left;line-height: 20px">
                                    A类
                                </div>
                                <div style="float: left;width: calc(100% - 50px)">
                                    <el-progress  :stroke-width="20"  :percentage="98"
                                                  style="margin-bottom: 5px;width: 100%">
                                    </el-progress>
                                    <span style="float: right;color: #4A90E2;font-size: 12px;">目标客户总数 53人，当月已拜访 53人</span>
                                </div>
                            </li>
                            <li style="margin-top: 16px;overflow: hidden;width: 100%">
                                <div style="width: 50px;height: 20px;float: left;line-height: 20px">
                                    A类
                                </div>
                                <div style="float: left;width: calc(100% - 50px)">
                                    <el-progress  :stroke-width="20"  :percentage="98"
                                                  style="margin-bottom: 5px;width: 100%">
                                    </el-progress>
                                    <span style="float: right;color: #4A90E2;font-size: 12px;">目标客户总数 53人，当月已拜访 53人</span>
                                </div>
                            </li>

                        </ul>
                    </div>
                </el-col>
            </el-row>
            <el-row style="margin-top: 20px">
                <el-col span="7" style="text-align: center">
                    <span style="font-size: 16px;color: #4A90E2;">签到拜访</span>
                </el-col>
                <el-col span="1" style="border: 1px transparent solid;">
                </el-col>
                <el-col span="7"  style="text-align: center">
                    <span style="font-size: 16px;color: #4A90E2;">其他工作</span>
                </el-col>
                <el-col span="1" style="border: 1px transparent solid;">
                </el-col>
                <el-col span="7"  style="text-align: center">
                    <span style="font-size: 16px;color: #4A90E2;">拜访覆盖率（所有渠道）</span>
                </el-col>
            </el-row>
        </el-row>
        <el-row style="margin-top: 10px">
            <el-table v-if="owenr_id === '0' || owenr_id === ''"
                      :data="tableData"
                      header-cell-class-name="tableClassName"
                      row-class-name="tableClassName"
                      style="width: 100%">
                <el-table-column
                        prop="date"
                        label="姓名"
                        sortable
                >
                </el-table-column>
                <el-table-column
                        prop="name"
                        label="签到客户数"
                        sortable
                >
                </el-table-column>
                <el-table-column
                        prop="address"
                        label="签到场所数"
                        sortable>
                </el-table-column>
                <el-table-column
                        prop="address"
                        sortable
                        label="开展会议数">
                </el-table-column>
                <el-table-column
                        prop="address"
                        sortable
                        label="辅导/协访次数">
                </el-table-column>
                <el-table-column
                        prop="address"
                        sortable
                        label="出差城市数">
                </el-table-column>
                <el-table-column
                        prop="address"
                        sortable
                        label="请假/休假天数">
                </el-table-column>
                <el-table-column
                        prop="address"
                        sortable
                        label="会议/培训天数">
                </el-table-column>
                <el-table-column
                        prop="address"
                        sortable
                        label="内部工作天数">
                </el-table-column>


            </el-table>
            <el-table v-if="owenr_id !== '0' && owenr_id !== ''"
                      :data="tableData1"
                      header-cell-class-name="tableClassName"
                      row-class-name="tableClassName"
                      style="width: 100%">
                <el-table-column
                        prop="date"
                        label="客户名称"
                        sortable
                >
                </el-table-column>
                <el-table-column
                        prop="name"
                        label="签到方式"
                        sortable
                >
                </el-table-column>
                <el-table-column
                        prop="address"
                        label="签入时间"
                        sortable>
                </el-table-column>
                <el-table-column
                        prop="address"
                        sortable
                        label="签出时间">
                </el-table-column>
                <el-table-column
                        prop="address"
                        sortable
                        label="拜访次数">
                </el-table-column>
                <el-table-column
                        prop="address"
                        sortable
                        label="出差城市数">
                </el-table-column>
                <el-table-column
                        prop="address"
                        sortable
                        label="参会次数">
                </el-table-column>
            </el-table>
        </el-row>
    </div>
</template>

<script>
    import inputSelect from '../../../../calendar/components/components/inputSelect'
    export default {
        name: "workreportmonth",
        data(){
            return {
                activeName:'日',
                value1:'',
                titleName:'人员',
                tableData: [{
                    date: '王晓云',
                    name: '4',
                    address: '0'
                }, {
                    date: '王晓云',
                    name: '3',
                    address: '0'
                }, {
                    date: '王晓云',
                    name: '2',
                    address: '0'
                }, {
                    date: '王晓云',
                    name: '2',
                    address: '0'
                }],
                tableData1: [{
                    date: '王晓云1',
                    name: '4',
                    address: '-'
                }, {
                    date: '王晓云1',
                    name: '3',
                    address: '-'
                }, {
                    date: '王晓云1',
                    name: '2',
                    address: '-'
                }, {
                    date: '王晓云1',
                    name: '2',
                    address: '-'
                }],
                owenr_id:this.GLOBAL.selectPeople_global
            }
        },
        components:{
            inputSelect
        },
        methods:{
            handleSelectInputClick(j){
                this.owenr_id = j
                this.GLOBAL.selectPeople_global = j
                this.titleName = this.GLOBAL.peopleName_global
                // this.init()
            },
        },
        mounted() {
            console.log(this.owenr_id)
        }
    }
</script>

<style scoped>
    #workreportmonth .li_span {
        color: #909399;
        font-size: 12px;
        display: inline-block;
        width: 70px;
        height: 100%;
        vertical-align:top
    }
    #workreportmonth .li {
        padding: 10px 0;
    }
    #workreportmonth .li_spanR{
        color: #909399;
        font-size: 12px;
        display: inline-block;
        width: calc(100% - 80px);
        vertical-align:top
    }
    #workreportmonth .workDayUl:before{
        content:" ";
        height: 100px;
        border: 1px solid #9FA5AC;
        float: right;
        margin-top: 40px;
    }
    #workreportmonth >>> .el-progress-bar{
        padding-right: 60px;
    }
    #workreportmonth >>> .el-progress-bar__outer{
        border-radius: 2px;
    }
    #workreportmonth >>> .el-progress-bar__inner{
        border-radius: 2px;
    }
    #workreportmonth >>> .tableClassName{
        font-size: 12px;
    }
</style>



// WEBPACK FOOTER //
// src/pages/dashboard/components/workreport/components/workreportmonth.vue